// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3zQ7p","checkboxCol":"Table_checkboxCol__2Em7V","emailCol":"Table_emailCol__39RGr","actionCol":"Table_actionCol__28KQs"};